import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PurchaseService = {
  // Define your API functions here
  getList: async () => {
    const response = await apiService.get("/purchases");
    return response.data;
  },
  create: async (postData) => {
    const response = await apiService.post("/purchases", postData);
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/purchases/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/purchases/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/purchases/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  markBillPaid: async (id) => {
    try {
      const response = await apiService.put(`/purchases/mark-bill-paid/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error marking bill as paid:", error);
      throw error;
    }
  },
};

export default PurchaseService;
